// 导入Contract控制器
import BasicWallet from "./basicWallet";

// 文件导入 abi
import erc20Abi from "../abi/erc20_abi.json";
import uniswapAbi from "../abi/uniswap_abi.json";
import fedtIdoAbi from "../abi/fedtIdo_abi.json";
import stakeMiningAbi from "../abi/stake_mining.json";

// 导入web3公共方法
import publicMethod from "../contract/publicMethod";
import uniSwap from "../contract/uniSwap";
import fedtIdoMethod from "../contract/fedtIdoMethod";

// 导入自定义方法


// 主体钱包公共方法
export default class MainWallet extends BasicWallet{
  tokenDecimal = 6;  // 主币-子币 精度
  lpTokenDecimal = 18; // LP币 精度
  usdtDecimal = 18;

  // 合约地址 
  panCakeRouterAddress = '0x10ED43C718714eb63d5aA57B78B54704E256024E'; // 交易合约


  // usdtTokenAddress = '0x61454D4be3941A708c514afce369c5755f75d144'; // USDT 合约地址
  
  // licensingContractsAddress = '0x7C257B81895B2801031709C7FB9c8e16423E914C' // 授权合约地址

  // idoAddress = '0xC7e50E3D9a5975B968ae84Cb802A8e261F234827'; //IDO私募合约

  // tokenAddress = '0x6CA7e6799ED0C6b55EE626b23FE5B8eD7fC22a8a'; // 本币合约

  // stakeAddress = '0x2644667ec3817FcA9Fc2d1FBc0cEB24FBf74115E'; // 质押合约

  // 正式网络上线

  usdtTokenAddress = '0x55d398326f99059fF775485246999027B3197955'; // USDT 合约地址
  
  licensingContractsAddress = '0x61454D4be3941A708c514afce369c5755f75d144' // 授权合约地址

  idoAddress = '0x30688dA5d7901A7Ef07fE5f00Df79aB2aAd019a5'; //IDO私募合约

  tokenAddress = '0x910F2c13E1ED58C3a5f2A61015F588990026C201'; // 本币合约

  stakeAddress = '0x2261F3F3D65973C826d7BB10D67c92691EFEc211'; // 质押合约
  

  // 构造器

  // 初始化合约方法
  async initOnInitFinished(data){
    let pancakeRouterContract  = await new uniSwap(data.web3.eth, uniswapAbi,this.panCakeRouterAddress,data.userAddress);
    this.setContract('pancakeRouterContract',pancakeRouterContract);

    let usdtTokenContract = await new publicMethod(data.web3.eth, erc20Abi, this.usdtTokenAddress, data.userAddress);
    this.setContract('usdtTokenContract', usdtTokenContract);

    let fedtTokenContract = await new publicMethod(data.web3.eth, erc20Abi, this.tokenAddress, data.userAddress);
    this.setContract('fedtTokenContract', fedtTokenContract);

    let stakeContract = await new publicMethod(data.web3.eth, stakeMiningAbi, this.stakeAddress, data.userAddress);
    this.setContract('stakeContract', stakeContract);

    let fedtIdoContract = await new fedtIdoMethod(data.web3.eth, fedtIdoAbi, this.idoAddress, data.userAddress);
    this.setContract('fedtIdoContract', fedtIdoContract);

  }

}